import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import { DATA_INPUT_RULES, access } from '../../access';

const DataInputSensorsList = withLazyLoading(() => import('../../pages/DataInput/DataInputSensorsList'));
const DataInputDetails = withLazyLoading(() => import('../../pages/DataInput/DataInputDetails'));

const dataInputRoutes = [
  {
    path: '/data-input',
    handle: createCrumbHandle('Data Input'),
    children: [
      {
        index: true,
        element: <DataInputSensorsList />,
        handle: access(DATA_INPUT_RULES.read),
      },
      {
        path: 'details/:id?',
        element: withPostHogTracker(<DataInputDetails />),
        handle: { ...createCrumbHandle('Details'), ...access(DATA_INPUT_RULES.read) },
      },
    ]
  },
];

export default dataInputRoutes;
